(function ($) {
  Drupal.behaviors.spp_howtouse_mobile_formatter_v1 = {
    attach: function (context, settings) {

      $.fn.equalHeightsName = function(px) {
        var currentTallest = 0;
        $(this).each(function(){
          if ($(this).height() > currentTallest) { currentTallest = $(this).height(); }
          if (!px && Number.prototype.pxToEm) currentTallest = currentTallest.pxToEm(); //use ems unless px is specified
        });
        $(this).each(function(){
          $(this).css({'min-height': currentTallest});
        });
        return this;
      };

      $('.spp-howtouse__products .text-product-listing-names').equalHeightsName();

      // in conflict with spp_mobile.js
      // $('.spp-product__additional-section-button').click(function(event) {
      //   event.preventDefault();
      //   $(this).parent().toggleClass('is_closed');
      // });

    }// attach
  };
})(jQuery);


